<template>
  <article class="tabs-container">
    <div class="tabs">
      <ul class="tabs-list" :class="{center: center}">
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          class="tabs-list__tab"
          :class="{ active: tab.isActive }"
          @click="selectTab(tab)"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
    <section class="tabs-details" :style="{ width: width + 'px' }">
      <slot :click="setTab"></slot>
    </section>
  </article>
</template>

<script>
export default {
  data() {
    return {
      tabs: [],
      width: ''
    }
  },

  props: {
    center: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    this.width = this.tabs[0].width
  },

  methods: {
    selectTab(tab) {
      this.tabs.forEach(el => {
        el.isActive = el.name === tab.name
      })
      this.width = tab.width
    },
    setTab(tab) {
      this.selectTab(tab)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tabs.scss';
</style>



// WEBPACK FOOTER //
// src/components/tabs/Tabs.vue